import React, {useEffect, useState} from "react";

import {ProgressBar} from 'primereact/progressbar';

import classes from "./TemplateGeneration.module.css"
import {downloadExcel, generateBdsZip, generateTemplateExcel} from "../../../../../api/file/download-service";
import {showError} from "../../../../../api/notification/ToastManager";
import DownloadButton from "./DownloadButton/DownloadButton";
import {
    isTemplateGenerationFailed,
    isTemplateGenerationInProgress
} from "../../../../../api/MarketNode/marketNode-status";

const TemplateGen = (props) => {
    const [templateIsDownloaded, setTemplateIsDownloaded] = useState(false)
    const [downloadCall, setDownloadCall] = useState(0)
    const buttonLabel = props.uploadMethod === "xlsx-ttl" ? "Template generation" : "BDS Generation"
    const [downloadProgress, setDownloadProgress] = useState({
        progress: 0,
        isDownloading: false,
        status: "",
        mode: "determinate"
    })


    /**
     * Download existing excel template
     * <p>
     * use downloadCall state to assert that download is called only once
     */
    const download = async () => {
        setDownloadCall(1);
        let fileName = `${props.dataCollection.name}_${props.marketNode.name}_${props.category['categoryDTO'].name.replaceAll(" ", "_")}.xlsx`
        await downloadExcel(fileName, props.category.template)
            .then(_ => {
                setTemplateIsDownloaded(false);
            })
    }

    /**
     * Check if template generation is in progress
     * - if true : set button loading
     * - else : generation has finished
     * <p>
     *     if button is already loading ( there was a generation in progress ) download the generation result
     * <p>
     *     else stop button loading
     * */
    useEffect(() => {
        if (props.uploadMethod === "xlsx-ttl") {
            if (isTemplateGenerationInProgress(props.category)) {
                setTemplateIsDownloaded(false);
            } else if (isTemplateGenerationFailed(props.category)) {
                setTemplateIsDownloaded(false);
            } else if (templateIsDownloaded && downloadCall === 0) {
                download().then();
            } else {
                setTemplateIsDownloaded(false);
            }
        }

    }, [props.category, downloadCall])

    function getOnDownloadProgress(progressEvent) {

        const total = progressEvent.total || 1
        const completed = Math.round((progressEvent.loaded * 100) / total);
        setDownloadProgress({
            isDownloading: true,
            progress: completed,
            status: `Downloading the file : ${completed}%`,
            mode: "determinate"
        })

    }

    /**
     * Call generate template service
     * - if response is 'true' (call is in waiting execution list) : update categories and continue loading
     * - else : stop loading button
     * */
    const generateTemplate = async () => {

        setTemplateIsDownloaded(true);
        setDownloadCall(0);
        const excelFileName = `${props.dataCollection.name}_${props.marketNode.name}_${props.category['categoryDTO'].name.replaceAll(" ", "_")}.xlsx`
        const zipBdsFileName = `${props.dataCollection.name}_boundary_points.zip`
        try {
            let result = null;
            if (props.uploadMethod === "xlsx-ttl") {
                result = await generateTemplateExcel({
                    "modelPath": props.modelPath,
                    "category": {id: props.category['categoryDTO'].id, name: props.category['categoryDTO'].name},
                    "sheets": [],
                    "copiedFrom": {dcId: 0, reuseDataOption: 'None'},
                    "dataCollection": props.dataCollection,
                    "marketNode": props.marketNode
                }, excelFileName)
            } else if (props.uploadMethod === "zip-xml") {
                setDownloadProgress({
                    isDownloading: true,
                    progress: 0,
                    status: `Compressing the file`,
                    mode: "indeterminate"
                })
                result = await generateBdsZip({
                        "dataCollection": props.dataCollection,
                        "category": {id: props.category['categoryDTO'].id, name: props.category['categoryDTO'].name},
                    }, zipBdsFileName,
                    getOnDownloadProgress)
            }
            setDownloadProgress({isDownloading: false, progress: 0, status: "", mode: "determinate"})
            setTemplateIsDownloaded(result)
            if (result) {
                props.findByDCAndMN()
            }

        } catch (e) {
            showError("Error", `An error occurs when generating ${props.category['categoryDTO'].name} template.`);
            setTemplateIsDownloaded(false);
        }

    }

    return (

        <div className="flex align-items-center justify-content-center">
            <div className="grid">
                <div className="col-12 flex align-items-center justify-content-center">
                    <span>
                        <label className={classes.title}>{buttonLabel}</label>
                    </span>
                </div>

                <div className="col-12 flex align-items-center justify-content-center">
                    <div>
                        <DownloadButton
                            uploadMethod={props.uploadMethod}
                            templateIsDownloaded={templateIsDownloaded}
                            downloadTemplate={() => generateTemplate()}
                            dataCollection={props.dataCollection}
                        />
                        {downloadProgress.isDownloading && <div>
                            <ProgressBar style={{height: "5px", marginTop: "1px"}} color={"#487c84"}
                                         value={downloadProgress.progress} showValue={false}
                                         mode={downloadProgress.mode}
                            />
                            <div className={"flex justify-content-center"}>
                                <span style={{fontSize: "12px"}}>{downloadProgress.status}</span>
                            </div>
                        </div>}
                    </div>
                </div>

                {props.dataCollection.copiedFrom !== null && props.dataCollection.copiedFrom.reuseDataOption !== "None"
                    ? (<div className="col-12 flex align-items-center justify-content-center mt-0 mb-0 pt-0 pb-0">
                        <span className="pi pi-info-circle pl-1"/>
                        <small className={classes.small}>Copied from Data Collection
                            "{props.dataCollection.copiedFrom.copiedFromDc.name}"</small>
                    </div>)
                    : null}
            </div>
        </div>
    )
}

export default TemplateGen;
